module.exports = __webpack_public_path__ + "img/4.4dc85cfe.webp";